import styled from 'styled-components';
import Image from 'next/image';
import { OntarioRow, color, media, spacing, typography } from '~/theme';
import colors from '~/theme/variables/colors';

export const MainContent = styled(OntarioRow).attrs({ as: 'main' })<{ $isDashboard: Boolean }>`
    padding: ${props => (props.$isDashboard ? spacing.spacing0 : spacing.spacing5)}
        ${spacing.spacing0} ${spacing.spacing6};
    min-height: calc(100vh - 368px);
    position: relative;
`;

export const InnerContainer = styled.div`
    width: 100%;
    padding-left: ${spacing.spacing4};
    padding-right: ${spacing.spacing4};
`;

export const VisuallyHiddenElement = styled.div`
    position: absolute;
    display: block;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    text-align: center;
`;

export const SkipLink = styled(VisuallyHiddenElement)`
    &:focus {
        position: static;
        left: 0;
        width: auto;
        height: auto;
        overflow: visible;
        padding: ${spacing.spacing2} ${spacing.spacing0};
        color: ${color.palette.black};
        outline: 4px solid transparent;
        border: 4px solid ${color.focusBlue};
        background-color: ${color.skipLinkBG};
        text-decoration: none;
        transition: border 0.1s ease-in-out;
    }
`;

export const GreenBg = styled.div`
    width: 100%;
    background-color: ${colors.palette.serviceOntarioGreen};
    position: absolute;
    height: 402px;

    @media ${media.small} {
        height: 286px;
    }
`;

export const TrilliumBgContainer = styled.div<{ $path?: string }>`
    width: 100%;
    background-color: ${({ $path }) =>
        $path === '/products/photo-card'
            ? colors.palette.systemLightPurple
            : colors.palette.systemLightBlue};
    position: absolute;
    height: 245px;

    @media ${media.small} {
        height: 245px;
    }
`;

export const TrilliumBgImage = styled(Image)`
    position: absolute;
    visibility: none;
    display: none;

    @media ${media.medium} {
        visibility: visible;
        display: block;
        left: 710px;
    }
`;
export const OntarioBadgeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing.spacing7};
    align-items: flex-start;
    padding: ${spacing.spacing5} ${spacing.spacing4};
`;

export const OntarioBadge = styled.span`
    display: inline-block;
    background-color: ${colors.palette.systemInformationBlue};
    color: ${colors.palette.greyscale70};
    padding: ${spacing.spacing1} ${spacing.spacing2};
    font-weight: ${typography.fontWeightBold};
    text-transform: uppercase;
`;

export const TrilliumBgImageStyled = styled(TrilliumBgImage)`
    position: absolute;
    visibility: none;
    display: none;

    @media ${media.medium} {
        visibility: visible;
        display: block;
        left: unset;
        right: 160px;
    }
`;

export default {
    InnerContainer,
    VisuallyHiddenElement,
    SkipLink,
};
